import {
  ConeGeometry,
  CylinderGeometry,
  Group,
  Mesh,
  MeshStandardMaterial,
  SphereGeometry
} from 'three';

/** Katarina mesh — red daggers silhouette. */
export function createKatarinaMesh(team = 'blue') {
  const group = new Group();
  const trim = team === 'blue' ? 0xef4444 : 0xfbbf24;
  const bodyMat = new MeshStandardMaterial({ color: 0x7f1d1d, roughness: 0.45 });
  const trimMat = new MeshStandardMaterial({ color: trim, roughness: 0.3, metalness: 0.4 });
  const body = new Mesh(new ConeGeometry(0.5, 1.9, 10), bodyMat);
  body.position.y = 1.1;
  group.add(body);
  const head = new Mesh(new SphereGeometry(0.34, 12, 12), trimMat);
  head.position.y = 2.3;
  group.add(head);
  const dagger = new Mesh(new CylinderGeometry(0.08, 0.08, 0.55, 4), trimMat);
  dagger.rotation.z = Math.PI / 4;
  dagger.position.set(0.55, 1.35, 0.15);
  group.add(dagger);
  return group;
}
